import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "../Input";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";
import useCrudTable from "@/hooks/Dashboard/useCrudTable";
import { RestaurantTable } from "@/redux/services/table/table.type";
import { ModalProps } from "@/lib/type";
import { Checkbox } from "@/components/ui/checkbox";
import { Error } from "@/components/Error";

type Props = ModalProps<RestaurantTable> & { restaurantId?: string };

const AddTableModal: React.FC<Props> = (props) => {
  const { isOpen, onClose, item, restaurantId } = props;

  const {
    register,
    onSubmit,
    errors,
    isLoading,
    handleAllowOrderPlacement,
    allowOrderPlacement,
  } = useCrudTable(onClose, item, restaurantId);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <form onSubmit={onSubmit}>
          <DialogTitle>
            {item ? "Modifier la" : "Ajouter une"} table
          </DialogTitle>

          <div className="mb-5">
            <Input
              label="Code"
              type="text"
              id="code"
              placeholder="Code"
              required
              {...register("code")}
              error={errors?.code}
              defaultValue={item?.code}
            />
          </div>

          <div className="mb-5">
            <div className="flex items-center gap-2">
              <Checkbox
                id="allow_order_placement_table"
                checked={allowOrderPlacement}
                onCheckedChange={handleAllowOrderPlacement}
              />
              <label htmlFor="allow_order_placement_table">
                Autoriser la prise de commande pour cette table
              </label>
            </div>
            <Error error={errors?.allowOrderPlacement} />
          </div>

          {/* <div className="mb-5">
            <Controller
              name="status"
              control={control}
              defaultValue={true}
              render={({ field }) => (
                <Switch
                  label="Disponibilité"
                  id="status"
                  defaultChecked={field.value}
                  onChange={onChangeStatus}
                />
              )}
            />
          </div> */}

          <DialogFooter>
            <Button type="submit" isLoading={isLoading}>
              {item ? "Modifier" : "Ajouter"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddTableModal;
